import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://admin.local.dev:8080';

/**
 * Service d'authentification pour Platform (super admin)
 */
class AuthService {
  /**
   * Login administrateur
   * @param {string} email 
   * @param {string} password 
   * @returns {Promise<Object>}
   */
  async login(email, password) {
    try {
      const response = await axios.post(`${API_URL}/auth/platform/login`, {
        email,
        password
      });

      if (response.data.success) {
        localStorage.setItem('platform_access_token', response.data.access_token);
        localStorage.setItem('platform_refresh_token', response.data.refresh_token);
        localStorage.setItem('platform_admin', JSON.stringify(response.data.administrator));
      }

      return response.data;
    } catch (error) {
      console.error('Erreur de login:', error);
      if (error.response?.data) {
        return error.response.data;
      }
      return {
        success: false,
        error: 'Erreur de connexion au serveur'
      };
    }
  }

  /**
   * Logout
   */
  logout() {
    localStorage.removeItem('platform_access_token');
    localStorage.removeItem('platform_refresh_token');
    localStorage.removeItem('platform_admin');
  }

  /**
   * Vérifie si l'utilisateur est authentifié
   * @returns {boolean}
   */
  isAuthenticated() {
    return !!localStorage.getItem('platform_access_token');
  }

  /**
   * Récupère le token d'accès
   * @returns {string|null}
   */
  getAccessToken() {
    return localStorage.getItem('platform_access_token');
  }

  /**
   * Récupère les informations de l'admin connecté
   * @returns {Object|null}
   */
  getAdmin() {
    const admin = localStorage.getItem('platform_admin');
    return admin ? JSON.parse(admin) : null;
  }

  /**
   * Configure axios avec le token d'authentification
   */
  setupAxiosInterceptors() {
    axios.interceptors.request.use(
      (config) => {
        const token = this.getAccessToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
          this.logout();
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }
    );
  }
}

export default new AuthService();
